export const USER = {
  firstName: "आदर्श ",
  lastName: "",
  displayName: "आदर्श त्रिपाठी ",
  username: "iaadarsh23",
  gender: "male",
  pronouns: "he/him",
  bio: "Creating with code. Small details matter.",
  flipSentences: [
    "Software Engineer",
    "Building products people love.",
    "Full Stack Developer",
    "Open source contributor.",
  ],

  address: "Noida",
  phoneNumber: "KzkxOTMxMDQ5NTYxNg==", // +919310495616 in base64 - your phone
  email: "YWRhcnNodHJpcDIzMDZAZ21haWwuY29t", // adarshtrip2306@gmail.com in base64 - your email
  website: "https://adarshtripathi.me",
  otherWebsites: [
    // Add your other websites here
  ],
  jobTitle: "Software Engineer",
  jobs: [
    {
      title: "Software Engineer",
    },
  ],
  about: `
  I am Adarsh Tripathi, a final-year Computer Science student dedicated to developing meaningful and impactful software solutions. My experience spans the design and implementation of full-stack web applications, scalable backend infrastructures, and intelligent, AI-driven tools—always with an emphasis on writing robust, maintainable code that delivers real value.

I believe exceptional outcomes are achieved through effective collaboration and clear communication within diverse teams. I take pride in my ability to build consensus, foster creativity, and inspire those around me. My approach is proactive—I anticipate challenges, consider long-term implications, and prioritize a seamless user experience while never losing sight of technical excellence or security.

My commitment to continuous learning is reflected in both my academic achievements and active contributions to open-source projects. Curiosity and a drive for improvement fuel my work, ensuring that I deliver high-quality and scalable solutions even under pressure. I take ownership of my projects from conception to deployment, always aiming to exceed expectations and uphold the highest standards.

If you value a self-motivated engineer who combines strong technical skills with a collaborative spirit and a strategic mindset, I welcome the opportunity to connect and contribute to your mission.
    `,
  avatar: "/images/Baki Hanma Pfp.jpeg", // Your profile picture
  ogImage: "/images/pp.jpg", // Same image for social media sharing
  namePronunciationUrl: "/audio/adarsh.mp3", // Add your audio file to public/audio/
  keywords:
    "adarsh, iaadarsh23, adarxh, developer, web developer, full stack developer",
  dateCreated: "2025-01-01", // Update with your project start date
};
